/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_PhraseInputs */

const en_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`search the web`)
};

const id_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telusuri web`)
};

const ms_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cari di web`)
};

const ca_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cercar al web`)
};

const cs_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prohledávejte web`)
};

const da_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`søg på nettet`)
};

const de_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsuche das Internet`)
};

const et_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`otsi veebist`)
};

const es_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`busca en la web`)
};

const fr_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rechercher sur le Web`)
};

const hr_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pretražite internet`)
};

const it_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca sul Web`)
};

const lv_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`meklēt tīmeklī`)
};

const lt_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ieškoti internete`)
};

const hu_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keresés az interneten`)
};

const nl_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zoeken op internet`)
};

const nb_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`søk på nettet`)
};

const pl_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wyszukaj w internecie`)
};

const pt_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pesquisar na web`)
};

const ro_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`caută pe web`)
};

const sk_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vyhľadávanie na webe`)
};

const sl_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iščite po spletu`)
};

const fi_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hae verkosta`)
};

const sv_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sök på nätet`)
};

const vi_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tìm trên web`)
};

const tr_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`web'i arayın`)
};

const el_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`αναζήτηση στο διαδίκτυο`)
};

const bg_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`търсене в мрежата`)
};

const ru_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`искать в интернете`)
};

const sr_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`претражите веб`)
};

const uk_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`шукати в Інтернеті`)
};

const ka_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ინტერნეტში ძიება`)
};

const hi_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वेब सर्च करें `)
};

const th_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเว็บ`)
};

const ko_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`웹 검색`)
};

const zh_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索网页`)
};

const zh_tw_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在網路上搜尋`)
};

const ja_search_action_phrase = /** @type {(inputs: Search_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`webを検索`)
};

/**
* | output |
* | --- |
* | "search the web" |
*
* @param {Search_Action_PhraseInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_action_phrase = /** @type {((inputs?: Search_Action_PhraseInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_PhraseInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_action_phrase(inputs)
	if (locale === "ms") return ms_search_action_phrase(inputs)
	if (locale === "ca") return ca_search_action_phrase(inputs)
	if (locale === "cs") return cs_search_action_phrase(inputs)
	if (locale === "da") return da_search_action_phrase(inputs)
	if (locale === "de") return de_search_action_phrase(inputs)
	if (locale === "et") return et_search_action_phrase(inputs)
	if (locale === "es") return es_search_action_phrase(inputs)
	if (locale === "fr") return fr_search_action_phrase(inputs)
	if (locale === "hr") return hr_search_action_phrase(inputs)
	if (locale === "it") return it_search_action_phrase(inputs)
	if (locale === "lv") return lv_search_action_phrase(inputs)
	if (locale === "lt") return lt_search_action_phrase(inputs)
	if (locale === "hu") return hu_search_action_phrase(inputs)
	if (locale === "nl") return nl_search_action_phrase(inputs)
	if (locale === "nb") return nb_search_action_phrase(inputs)
	if (locale === "pl") return pl_search_action_phrase(inputs)
	if (locale === "pt") return pt_search_action_phrase(inputs)
	if (locale === "ro") return ro_search_action_phrase(inputs)
	if (locale === "sk") return sk_search_action_phrase(inputs)
	if (locale === "sl") return sl_search_action_phrase(inputs)
	if (locale === "fi") return fi_search_action_phrase(inputs)
	if (locale === "sv") return sv_search_action_phrase(inputs)
	if (locale === "vi") return vi_search_action_phrase(inputs)
	if (locale === "tr") return tr_search_action_phrase(inputs)
	if (locale === "el") return el_search_action_phrase(inputs)
	if (locale === "bg") return bg_search_action_phrase(inputs)
	if (locale === "ru") return ru_search_action_phrase(inputs)
	if (locale === "sr") return sr_search_action_phrase(inputs)
	if (locale === "uk") return uk_search_action_phrase(inputs)
	if (locale === "ka") return ka_search_action_phrase(inputs)
	if (locale === "hi") return hi_search_action_phrase(inputs)
	if (locale === "th") return th_search_action_phrase(inputs)
	if (locale === "ko") return ko_search_action_phrase(inputs)
	if (locale === "zh") return zh_search_action_phrase(inputs)
	if (locale === "zh-tw") return zh_tw_search_action_phrase(inputs)
	if (locale === "ja") return ja_search_action_phrase(inputs)
	return en_search_action_phrase(inputs)
});